import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { RequestsService } from 'src/app/user-management/_services/requests.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { Router } from '@angular/router';
import { SelectSearchFilter } from 'src/app/shared/select-search-filter';
declare var $: any;
@Component({
  selector: 'app-edit-request-card',
  templateUrl: './edit-request-card.component.html',
  styleUrls: ['./edit-request-card.component.scss']
})
export class EditRequestCardComponent implements OnInit,OnDestroy {
  // this card's own file input — never look it up by id, the student modal opened
  // from the same listing page used to share it and getElementById picked this one
  @ViewChild('fileUploadInput') fileUploadInput: ElementRef<HTMLInputElement>;
  editRequestForm: UntypedFormGroup;
  currLang;
  grades: any[];
  classes:any[];
  gradeSearch = new SelectSearchFilter<any>('name');
  classSearch = new SelectSearchFilter<any>('name');
  imageFile;
  selectedImage;
  image;
  requestDataSubscription;
  @Input("requestData") requestData = null;

  constructor(
    private dataService: DataService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private requestsService: RequestsService,
    private errorMsgService: ErrorMsgService,
    private router: Router,

  ) {}

  ngOnInit(): void {    
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    $(document).on('hidden.bs.modal', '#editCard', () => {
      this.closeModalHandler();
    });

    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });

    this.dataService.getAllGrades().subscribe(res => {
      this.grades = res;
      this.gradeSearch.setSource(this.grades);
    })

    $(document).on('shown.bs.modal', '#editCard', () => {
      if(!!this.requestData){
        this.fillFormFields();
      }
    })  

    this.editRequestForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required,Validators.pattern(/[\S]/g)]),
      grade_id: new UntypedFormControl('', Validators.required),
      class_id: new UntypedFormControl('', Validators.required),
    })
  }

  onGradeChange() {
    this.editRequestForm.controls.class_id.reset();
    let selectedGrade: any;
    selectedGrade = this.grades.filter(grade => grade.id === this.editRequestForm.value.grade_id);
    this.classes = selectedGrade[0]?.school_classes;
    this.classSearch.setSource(this.classes);
    this.classSearch.reset();
    if (this.classes?.length === 0) {
      this.editRequestForm.controls.class_id.setErrors({ 'required': true })
      this.editRequestForm.controls.class_id.markAsTouched();
    }
  }

  fillFormFields(){
    this.editRequestForm.get('name').setValue(this.requestData?.new_values?.hasOwnProperty('name')?this.requestData?.new_values?.name:this.requestData?.student?.name);
    this.editRequestForm.get('grade_id').setValue(!!this.requestData?.new_school_class?this.requestData?.new_school_class?.grade?.id:this.requestData?.student?.class?.grade?.id);
    this.onGradeChange();
    this.editRequestForm.get('class_id').setValue(!!this.requestData?.new_school_class?this.requestData?.new_school_class?.id:this.requestData?.student?.class?.id);
    this.image = this.requestData?.new_values.hasOwnProperty('image')?this.requestData?.new_values?.image:environment.img_url + this.requestData?.student?.image_path;
  }
  changeStudentProfile() {
    const fileUpload = this.fileUploadInput?.nativeElement;
    if (!fileUpload) {
      return;
    }
    // clearing the value first so re-picking the same file still fires `change`
    fileUpload.value = null;
    fileUpload.click();
  }

  onFileSelected(file: FileList) {
    const picked = file?.item(0);
    if (!picked) {
      return;
    }
    // the upload payload and the preview are set together, so they can never diverge
    this.imageFile = picked;
    this.selectedImage = picked;
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.image = event.target.result;
    };
    reader.readAsDataURL(picked);
  }

  closeModalHandler() {
    this.fillFormFields();
    this.requestData = null;
    // this.image = null;
    // this.imageFile=null;
    // this.editRequestForm.reset();
    this.gradeSearch.reset();
    this.classSearch.reset();
    $("#editCard").modal("hide");
  }

  approveEdit(){
    let currentUrl = this.router.url
    const formData = new FormData();
    if (this.imageFile) {
      formData.append('image', this.imageFile);
    }

    for (const i in this.editRequestForm.value) {
      formData.append(i, this.editRequestForm.value[i])
    }

    formData.append('_method','PUT');

    this.requestsService.editEditRequestByAdmin(this.requestData.id,formData).subscribe(res=>{
      this.router.navigateByUrl(`/`,{skipLocationChange:true}).then(() => {
        this.router.navigate([currentUrl]);
    });   
    },
    err=>{
      this.errorMsgService.setMessage(err?.error?.message);
    }) 
  }
  ngOnDestroy() {
    this.gradeSearch.destroy();
    this.classSearch.destroy();
  }
}
